module.exports = __webpack_public_path__ + "img/1982.aab13b49.svg";